export default __webpack_public_path__ + "static/media/next-arrow.2fe80e2d.svg";